export const DEFAULT_PREFIX_VALUE = "alphabet-yellow-";
export const DEFAULT_BLANK_VALUE = ":blank:"
export const DEFAULT_WORD_MAP_VALUE = {};
export const DEFAULT_SPACES_BETWEEN_EMOJI_VALUE = false;
